// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const signatureSchema = z.object({
  signature: z.string(),
  validUntil: z.number(),
})
